import { type FC } from "react";

import { Avatar, AvatarSize, AvatarType } from "../../lib/Avatar";
import { type ButtonSize } from "../../lib/Button";
import { type ReactionUser } from "./ReactionUser";

export const ReactionPopoverContent: FC<{
	size: ButtonSize;
	reactionsValue: ReactionUser[];
}> = ({ size, reactionsValue }) => {
	// Avoid empty black box when there are no reactions.
	if (reactionsValue.length === 0) {
		return null;
	}

	let mappedSize = AvatarSize.xxs;
	switch (size) {
		case "lg":
			mappedSize = AvatarSize.md;
			break;
		case "md":
			mappedSize = AvatarSize.sm;
			break;
		case "sm":
			mappedSize = AvatarSize.xs;
			break;
		default:
			mappedSize = AvatarSize.xxs;
			break;
	}

	return (
		<div className="flex flex-col space-y-2">
			{reactionsValue.map((reaction) => {
				return (
					<div className="flex flex-row items-center space-x-2" key={reaction.id}>
						<Avatar
							userName={reaction.name}
							avatarType={AvatarType.Image}
							size={mappedSize}
							imageURL={reaction?.profilePicture}
						/>
						<div>{reaction.name}</div>
					</div>
				);
			})}
		</div>
	);
};
